import React from 'react';
import { SFEntityID } from 'utils/types';
import { hot } from 'react-hot-loader';
import { withNotification } from '../common/withNotification';
import { SFNotification } from 'utils/types';
import ScoreDefinitionsContainer from './scoreFactors/ScoreDefinitionsContainer';

class App extends React.Component {

  render() {
    return (
      <React.Fragment>
          {this.props.notification.render()}
          <ScoreDefinitionsContainer studentId={this.props.studentId} 
                                     onFailure={this.props.notification.error} />
      </React.Fragment>
    );
  }
}

App.propTypes = {
  studentId: SFEntityID.isRequired,
  notification: SFNotification.isRequired
};

export default hot(module)(withNotification(App));
